<template>
  <div class="home">Bạn đang cố gắng truy cập trang không được cấp quyền.</div>
</template>
<style>
 .p-datatable {
   font-family: "Open Sans", "Helvetica Neue", sans-serif!important;
   font-size: 13px!important;
 }
 .p-inputtext {
  font-family: "Open Sans", "Helvetica Neue", sans-serif!important;
  font-size: 13px!important;
 }
 .p-component {
  font-family: "Open Sans", "Helvetica Neue", sans-serif!important;
  font-size: 13px!important; 
 }
 /* .p-dialog-header-close-icon {
   display: none!important;
 } */
</style>
<script>
//import $ from 'jquery'
export default {
  name: 'Home',
  created() {

  },
}
</script>
